/**
 * Deterministic per-user color for presence (Plan v3-01).
 *
 * Picks from a small fixed palette so two users at adjacent hash
 * buckets never end up indistinguishable. Pure (no Crypto API
 * dependency) so the value matches across SSR + hydration.
 */

const PRESENCE_PALETTE = [
  '#ef4444', // red-500
  '#f97316', // orange-500
  '#eab308', // yellow-500
  '#22c55e', // green-500
  '#06b6d4', // cyan-500
  '#3b82f6', // blue-500
  '#8b5cf6', // violet-500
  '#ec4899', // pink-500
] as const;

export function presenceColorForUserId(userId: string): string {
  let hash = 5381;
  for (let i = 0; i < userId.length; i += 1) {
    hash = ((hash << 5) + hash + userId.charCodeAt(i)) | 0;
  }
  return PRESENCE_PALETTE[Math.abs(hash) % PRESENCE_PALETTE.length];
}
